import { useCallback, useState } from 'react';

const useCallbackRef = <ElementType = HTMLDivElement>() => {
  const [value, setValue] = useState<{ current: ElementType }>({
    current: null,
  });

  const ref = useCallback(
    (ref: ElementType) => {
      if (ref && !value.current) {
        setValue({ current: ref });
      }
    },
    [value],
  );

  return [value, ref];
};

export default useCallbackRef;
